<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      :dark="dark"
    >
      <v-toolbar :dark="dark" color="primary">
        <v-btn icon :dark="dark" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title v-if="selectedRoom.name">Rediger {{selectedRoom.name}}</v-toolbar-title>
        <v-toolbar-title v-else-if="selectedRoom.type">Rediger {{selectedRoom.type.name}}</v-toolbar-title>
        <v-toolbar-title v-else>Nytt rom</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-flex xs12>
            <v-select
              label="Romtype"
              v-model="selectedRoomType"
              :items="roomTypeList"
              :append-outer-icon="selectedRoomType.icon"
              item-text="name"
              item-value="id"
              return-object
              box
            ></v-select>
          </v-flex>
          <v-flex xs12 class="mb-5">
            <v-text-field box label="Navn på rom" clearable v-model="selectedRoom.name"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="selectedRoom.type">
            <v-tabs centered color="info" v-model="active_tab" :dark="dark" icons-and-text>
              <v-tabs-slider color="info lighten-4"></v-tabs-slider>

              <v-tab href="#tab-info">
                Om rommet
                <v-icon>mdi-information</v-icon>
              </v-tab>

              <v-tab href="#tab-contents">
                Innhold
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-tab>

              <v-tab href="#tab-pictures">
                Bilder
                <v-icon>mdi-camera</v-icon>
              </v-tab>
              <v-tabs-items>
                <v-tab-item value="tab-info">
                  <v-card flat>
                    <v-card-text class="pr-0 pl-0">
                      <h4>Om rommet:</h4>
                      <v-layout wrap>
                        <v-flex xs12 sm4 class="mt-4 pr-sm-2">
                          <v-select
                            label="Gulvtype"
                            v-model="selectedRoom.floorType"
                            :items="selectedRoom.type.floorTypes.options"
                            item-text="title"
                            item-value="id"
                            box
                            return-object
                            multiple
                            chips
                            deletable-chips
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm4 class="mt-4 pl-sm-2 pr-sm-2">
                          <v-select
                            label="Veggtype"
                            v-model="selectedRoom.wallType"
                            :items="selectedRoom.type.wallTypes.options"
                            item-text="title"
                            item-value="id"
                            box
                            return-object
                            multiple
                            chips
                            deletable-chips
                            :dark="dark"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm4 class="mt-4 pr-sm-2" v-if="selectedRoom.type.ceilingTypes.options.length > 0">
                          <v-select
                            label="Himling"
                            v-model="selectedRoom.ceilingType"
                            :items="selectedRoom.type.ceilingTypes.options"
                            item-text="title"
                            item-value="id"
                            box
                            return-object
                            multiple
                            chips
                            deletable-chips
                            :dark="dark"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 class="mt-2 pr-sm-2">
                          <v-select
                            label="Lyskilder"
                            v-model="selectedRoom.lightingType"
                            :items="selectedRoom.type.lightingTypes.options"
                            item-text="title"
                            item-value="id"
                            box
                            return-object
                            multiple
                            chips
                            deletable-chips
                            :dark="dark"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 class="mt-2 pl-sm-2">
                          <v-select
                            label="Varmekilder"
                            v-model="selectedRoom.heatingType"
                            :items="selectedRoom.type.heatingTypes.options"
                            item-text="title"
                            item-value="id"
                            box
                            return-object
                            multiple
                            chips
                            deletable-chips
                            :dark="dark"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 class="mt-2 pr-sm-2">
                          <v-text-field box label="Størrelse" type="number" v-model="selectedRoom.size" suffix="m2"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="mt-2 pl-sm-2">
                          <v-text-field box label="Etasje" type="number" v-model="selectedRoom.floorNumber" suffix="etg"></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="mt-2">
                          <v-textarea box label="Kommentar" v-model="selectedRoom.comment" rows="5"></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                          <div class="text-right mb-4">
                            <v-btn fab :dark="dark" color="primary" @click="active_tab = 'tab-contents'">
                              <v-icon :dark="dark">mdi-format-list-bulleted</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-contents">
                  <v-card flat>
                    <v-card-text class="pr-0 pl-0">
                      <h4>Innhold:</h4>
                      <BooleanInputTable objectTitle="Objekt" boolTitle="Tilstand ok?" commentTitle="Kommentar" v-model="selectedRoom.type.contentTypes.options" @update-fields="updateMessage"></BooleanInputTable>
                      <v-layout row class="mb-4">
                        <v-flex xs6 class="text-left">
                          <v-btn fab :dark="dark" color="primary" @click="active_tab = 'tab-info'">
                            <v-icon :dark="dark">mdi-information</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 class="text-right">
                          <v-btn fab :dark="dark" color="primary" @click="active_tab = 'tab-pictures'">
                            <v-icon :dark="dark">mdi-camera</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-pictures">
                  <ImageUploadBox :images="selectedRoom.images"></ImageUploadBox>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-flex>
        </v-card-text>
        <v-footer color="white" fixed class="pt-2 pb-2">
          <v-flex text-xs-center>
            <v-btn color="success" block @click="closeDialog">Lagre / lukk</v-btn>
          </v-flex>
        </v-footer>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import ROOMTYPES from "../../../models/roomTypes";
import RoomTypeFactory from "../../../models/roomTypeFactory";
import BooleanInputTable from "../../form/BooleanInputTable.vue";
import ImageUploadBox from "../../upload/ImageUploadBox.vue";

export default {
  data() {
    return {
      active_tab: "tab-info",
      roomTypes: ROOMTYPES,
      imageDialog: false,
      selectedImage: { comment: "" }
    };
  },
  components: { BooleanInputTable, ImageUploadBox},
  props: ["dialog", "selectedRoom"],
  mounted: function() {
  },
  methods: {
    updateMessage(e) {
      this.$emit("update-fields");
    },
    addNewRoom() {
      this.$emit("add-room", this);
    },
    closeDialog() {
      this.selectedRoom.active_tab = this.active_tab;
      this.$emit("close-edit-room-dialog");
    },
    openImageDialog(image) {
      this.selectedImage = image;
      this.imageDialog = true;
    },
    addNewImage(image) {
      this.selectedRoom.images.push(image);
    },
    deleteImage(i) {
      this.selectedRoom.images.splice(i, 1);
    }
  },
  computed: {
    roomTypeList: {
      get() {
        let arr = [];
        for (var propertyName in this.roomTypes) {
          arr.push(RoomTypeFactory.createInstance(propertyName));
        }
        return arr;
      }
    },
    selectedRoomType: {
      get() {
        return this.selectedRoom.type;
      },
      set(type) {
        this.selectedRoom.type = RoomTypeFactory.createInstance(
          type.id
        );
      }
    },
    dark: {
      get() {
        if (this.$store.state.protocol.dark) {
          return this.$store.state.protocol.dark;
        }
        return false;
      }
    }
  },
  watch: {
    selectedRoom: function(newVal, oldVal) {
      // watch it
      if (
        typeof newVal.active_tab !== "undefined" ||
        newVal.active_tab !== null
      ) {
        this.active_tab = newVal.active_tab;
      } else {
        this.active_tab = "tab-condition";
      }
    }
  }
};
</script>

<style>
a:hover {
  text-decoration: none;
  color: #fff;
}
.cld-image img {
    width: 100%;
    height: auto;
  }

</style>